var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C4DB;}\n\t.st1{fill:#FF9D9C;}\n\t.st2{fill:#9BEAF9;}\n\t.st3{fill:#E9F4BC;}\n\t.st4{fill:#505050;}\n\t.st5{fill:#FEBECC;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#FDE4A1;}\n\t.st8{fill:#FEE7B5;}\n\t.st9{fill:#CDF6FC;}\n\t.st10{fill:#F2C6DD;}\n\t.st11{opacity:0.1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.25,27.12c-11.6,0-21,9.4-21,21h42C43.25,36.53,33.85,27.12,22.25,27.12z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 6,
    width: 46,
    x: 2,
    y: 2.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 29.95,
    width: 39.88,
    x: 5.06,
    y: 8.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.63,12.43v7h7C24.63,15.56,21.49,12.43,17.63,12.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M15.25,14.8c-3.87,0-7,3.13-7,7c0,1.93,0.78,3.68,2.05,4.95l4.95-4.95V14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.25,21.8l-4.95,4.95c1.27,1.27,3.02,2.05,4.95,2.05c3.87,0,7-3.13,7-7H15.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 19.2,
    width: 3.19,
    x: 38.76,
    y: 16.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 12.2,
    width: 3.19,
    x: 32.36,
    y: 23.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 5.2,
    width: 3.19,
    x: 25.97,
    y: 30.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9,9.36c0.42,0,0.75-0.33,0.75-0.74c0-0.42-0.33-0.75-0.75-0.75c-0.41,0-0.75,0.33-0.75,0.75     C8.25,9.04,8.59,9.36,9,9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.53,2.09C48.39,1.95,48.2,1.88,48,1.88H2c-0.2,0-0.39,0.08-0.53,0.22C1.33,2.23,1.25,2.43,1.25,2.61v6.01     c0,0.19,0.08,0.39,0.22,0.53C1.61,9.29,1.8,9.36,2,9.36h2.31v29.2c0,0.41,0.34,0.75,0.75,0.75h19.19v2.17     c-1.15,0.33-2,1.38-2,2.63c0,1.52,1.23,2.75,2.75,2.75s2.75-1.23,2.75-2.75c0-1.25-0.85-2.3-2-2.63v-2.17h19.19     c0.41,0,0.75-0.34,0.75-0.75V9.36H48c0.2,0,0.39-0.07,0.53-0.22c0.14-0.13,0.22-0.32,0.22-0.52V2.61     C48.75,2.42,48.67,2.23,48.53,2.09z M26.25,44.12c0,0.69-0.56,1.25-1.25,1.25s-1.25-0.56-1.25-1.25s0.56-1.25,1.25-1.25     S26.25,43.43,26.25,44.12z M47.25,7.88H11c-0.41,0-0.75,0.33-0.75,0.75c0,0.41,0.34,0.74,0.75,0.74H44.2v28.45H25.01c0,0,0,0,0,0     s0,0,0,0H5.81V9.36H7c0.42,0,0.75-0.33,0.75-0.74c0-0.42-0.33-0.75-0.75-0.75H2.75V3.36h44.5V7.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.25,29.55c4.27,0,7.75-3.48,7.75-7.75c0-0.41-0.34-0.75-0.75-0.75H16V14.8c0-0.41-0.34-0.75-0.75-0.75     c-4.27,0-7.75,3.48-7.75,7.75S10.97,29.55,15.25,29.55z M21.45,22.55c-0.37,3.09-3.01,5.5-6.21,5.5c-1.45,0-2.79-0.5-3.85-1.34     l4.16-4.16H21.45z M14.5,15.6v5.89l-4.16,4.16C9.5,24.59,9,23.26,9,21.8C9,18.61,11.4,15.97,14.5,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.63,20.18h7c0.41,0,0.75-0.34,0.75-0.75c0-4.27-3.48-7.75-7.75-7.75c-0.41,0-0.75,0.34-0.75,0.75v7     C16.88,19.84,17.21,20.18,17.63,20.18z M18.38,13.22c2.85,0.34,5.11,2.61,5.46,5.46h-5.46V13.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.76,36.32h3.19c0.41,0,0.75-0.34,0.75-0.75v-19.2c0-0.41-0.34-0.75-0.75-0.75h-3.19     c-0.41,0-0.75,0.34-0.75,0.75v19.2C38.01,35.98,38.34,36.32,38.76,36.32z M39.51,17.12h1.69v17.7h-1.69V17.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32.36,36.32h3.19c0.41,0,0.75-0.34,0.75-0.75v-12.2c0-0.41-0.34-0.75-0.75-0.75h-3.19     c-0.41,0-0.75,0.34-0.75,0.75v12.2C31.61,35.98,31.95,36.32,32.36,36.32z M33.11,24.12h1.69v10.7h-1.69V24.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.22,35.57c0,0.41,0.34,0.75,0.75,0.75h3.19c0.41,0,0.75-0.34,0.75-0.75v-5.2c0-0.41-0.34-0.75-0.75-0.75     h-3.19c-0.41,0-0.75,0.34-0.75,0.75V35.57z M26.72,31.12h1.69v3.7h-1.69V31.12z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e8e122c1c6e8a2355fc035bb4c5e15fd.svg";
export { ForwardRef as ReactComponent };